import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export interface ILoagindCompProps {
	isopen: boolean;
}

export const LoadingComp: React.FC<ILoagindCompProps> = ({ isopen }) => {
	return (
		<Backdrop sx={{ color: "#fff", zIndex: 1400 }} open={isopen}>
			<CircularProgress color="inherit" size={"100px"} thickness={1} />
		</Backdrop>
	);
};
